module.exports = __webpack_public_path__ + "static/media/authBg.85b0d4b9.jpg";